// src/redux/slices/subscriptionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubscriptionState, SubscriptionData } from '../../types/subscription';

const initialState: SubscriptionState = {
  data: null,
  loading: false,
  error: null,
  hasCommerceAI: false,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    fetchSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSubscriptionSuccess: (state, action: PayloadAction<SubscriptionData>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
      
      // Check if commerce_ai addon exists and is active
      // AND subscription is not cancelled
      const hasActiveCommerceAI = action.payload.price?.some(
        (price) => {
          const addonKey = price.addonKey?.toString().trim().toLowerCase();
          const priceName = price.name?.toString().trim().toLowerCase();
          const isActive = price.status === 'active';
          
          return (
            (addonKey === 'commerce_ai' || priceName === 'commerce ai') && 
            isActive
          );
        }
      ) || false;
      
      const isSubscriptionActive = action.payload.subscriptionStatus !== 'cancelled';
      
      state.hasCommerceAI = hasActiveCommerceAI && isSubscriptionActive;
    },
    fetchSubscriptionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.hasCommerceAI = false;
    },
    clearSubscription: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.hasCommerceAI = false;
    },
  },
});

export const {
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
  clearSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
